import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-lesson-ani',
  templateUrl: './lesson-ani.component.html',
  styleUrls: ['./lesson-ani.component.css', 'dragula.min.css']
})
export class LessonAniComponent implements OnInit {

  constructor() { }

  question = ["1", "2", "3", "4", "5", "6"]
  answersArray = []
  vpids = [
    'vpid-1',
    'vpid-2',
    'vpid-3',
    'vpid-4'
  ]
  ngOnInit(): void {
    let options = {
      root: null,
      rootMargin: '100px',
      threshold: 0.25
    }
    
    let observer = new IntersectionObserver(console.log, options);

    observer.observe
  }

  onDrop(event: CdkDragDrop<string[]>, id: string) {   
 
    if (event.previousContainer === event.container) {
      
      moveItemInArray(this.question, event.previousIndex, event.currentIndex);
      console.log(this.question)
    } else {

      console.log(event)
      
    }
}

}
